import React, { useRef, useState, useEffect } from "react";
import useHttp from "../../../hooks/use-http";
import moment from "moment";
import { toast } from "react-toastify";
import Modal from "react-modal";
import id from "date-fns/locale/id/index.js";

const DistributionToMobileUserForm = (props) => {
  const frmRef = useRef({});
  const productRef = useRef({});
  const [productData, setProductData] = useState([]);
  const [productId, setProductId] = useState(0);
  const [productDetails, setProductDetails] = useState([]);
  const [unitId, setunitId] = useState();
  const [loading, setLoading] = useState(false);
  const [decimalPattern, setDecimalPattern] = useState(
    localStorage.getItem("decimalPattern")
  );
  const [seasonlist, setSeasonlist] = useState(null);
  const [selectedSeasonId, setSelectedSeasonId] = useState();
  const [qtyPerHa, setQtyPerHa] = useState();
  const [vendorData, setVendorData] = useState([]);
  const [selectedVendorId, setSelectedVendorId] = useState();

  const [inputTemplateDetail, setInputTemplateDetail] = useState([]);
  const [farmerInputTemplateId, setFarmerInputTemplateId] = useState("");

  const [farmerData, setFarmerData] = useState();
  const [selectedFarmerId, setSelectedFarmerId] = useState();
  const [areaInHa, setAreaInHa] = useState(0);

  const [warehosuedata, setWarehosuedata] = useState([]);
  const [warehouseId, setWarehouseId] = useState();

  const [selectedDate, setSelectedDate] = useState(
    new Date().toISOString().substr(0, 10)
  );


  const [employeelist, setEmployeelist] = useState(null);
  const [assignEmployeeId, setAssignEmployeeId] = useState();
  const [availableAmount, setAvailableAmount] = useState();
  const [pricePerUnit, setPricePerUnit] = useState();
  

  const currentDate = new Date().toISOString().slice(0, 10);
  var d = new Date();
  var dateString =
    d.getDate() + "/" + (d.getMonth() + 1) + "/" + d.getFullYear();
  //  +
  // " " +
  // d.getHours() +
  // ":" +
  // d.getMinutes() +
  // ":" +
  // d.getSeconds();

  const handleDateChange = (e) => {
    setSelectedDate(e.target.value);
  };

  const { sendRequest: getSeason } = useHttp();
  useEffect(() => {
    getSeason(
      {
        url: `/api/seasons/?orgId=${localStorage.getItem("orgId")}&&createdBy=${localStorage.getItem("id")}`,
      },
      (data) => {
        // console.log("season", data);
        setSeasonlist(data);
      }
    );
  }, [getSeason]);


  const { sendRequest: getEmp } = useHttp();
  useEffect(() => {
    getEmp(
      {
         
        url: `/api/fillEmployeeListForOperation/?orgId=${localStorage.getItem("orgId")}&&useCase=${localStorage.getItem("useCase")}&&createdBy=${localStorage.getItem("id")}`,
        //url: `/api/getEmps/?orgId=${localStorage.getItem("orgId")}`,
      },
      (data) => {
        console.log(" emp data",data.output)
        // var empData=data.output.filter(user => user.useCase=="Procurement");
        // console.log("empData",empData)
        
        setEmployeelist(data.output);
      }
    );
  }, [getEmp]);



  const { sendRequest: getWarehouseData } = useHttp();

  const getWarehouseDetail = () => {
    getWarehouseData(
      {
        // url: `/api/warehouses/?orgId=${localStorage.getItem("orgId")}&&createdBy=${localStorage.getItem("id")}`,
        url: `/api/warehouses/?orgId=${localStorage.getItem("orgId")}&&storeTypeId=1&&createdBy=${localStorage.getItem("id")}`,
      },
      (res) => {
        if (res) {
          //console.log("warehouse data", res);
          setWarehosuedata(res);
        }
      }
    );
  };

  useEffect(() => {
    getWarehouseDetail();
  }, [getWarehouseData]);

  const { sendRequest: getFarmerInputTemplate } = useHttp();

  const getFarmerInputTemplateData = () => {
    getFarmerInputTemplate(
      {
        url: `/api/farmerInputTemplateWithStock/?orgId=${localStorage.getItem(
          "orgId"
        )}&warehouseId=${localStorage.getItem("warehouseId")}`,
      },
      (res) => {
        // console.log("farmerdata", res);
        if (res) {
          setFarmerData(res);
        }
      }
    );
  };

  useEffect(() => {
    getFarmerInputTemplateData();
  }, [getFarmerInputTemplate]);

   

  const { sendRequest: getExecutiveArea } = useHttp();

  const loadExecutiveArea = (id,seasonId) => {
    frmRef.current.areaInHa.value = "0";
    

    getExecutiveArea(
      {
        url: `/api/getFieldExecutiveAreaBySeason/?orgId=${localStorage.getItem(
          "orgId"
        )}&fieldExecutiveId=${id}&seasonId=${seasonId}`,
        method: "GET",
         
      },
      (myres) => {
        // console.log("getAvailableStock", res);
        if (myres)
          { 
          var res=myres.data
            var araobj=res[0]
            console.log("araobj", araobj)
            console.log("totalArea", araobj["totalArea"])
            frmRef.current.areaInHa.value = araobj["totalArea"];
            setAreaInHa( araobj["totalArea"]) 
          }      
      }
    );
  };



  const { sendRequest: getproduct } = useHttp();

  const getProductDetail = () => {
    getproduct(
      {
        url: `/api/product/?orgId=${localStorage.getItem("orgId")}&&createdBy=${localStorage.getItem("id")}`,
      },
      (res) => {
        if (res) {
          //console.log("product", res);
          setProductData(res);
        }
      }
    );
  };

  useEffect(() => {
    getProductDetail();
  }, [getproduct]);

  const { sendRequest: getAvailableStock } = useHttp();

  const loadStockData = (id) => {
    productRef.current.productSubType.value = "";
    // productRef.current.productType.value = "";

    var itemlist = productData.filter((item) => item.productId == id);
    var selectedItem = itemlist[0];

    productRef.current.productSubType.value = selectedItem.productSubTypeName;
    // productRef.current.productType.value = selectedItem.productTypeName;
    const data = {
      warehouseId: localStorage.getItem("warehouseId"),
      productId: id,
    };

    getAvailableStock(
      {
        url: "/api/getAvailableStock/",
        method: "POST",
        body: data,
      },
      (myres) => {
        var res=myres.data
        // console.log("getAvailableStock", res);
        productRef.current.availableQty.value = res.availableQty;
        productRef.current.unitName.value = res.unitName;
        productRef.current.pricePerUnit.value = res.pricePerUnit;
        productRef.current.qtyPerHa.value = res.qtyPerHa;
           
        // productRef.current.availableAmount.value = res.availableAmount ?? 0;
        setAvailableAmount(res.availableAmount ?? 0);
        setunitId(res.unitId);
        setPricePerUnit(res.pricePerUnit??0)
        console.log("getAvailableStock", res);
        CalculateGoodsQty(frmRef.current.areaInHa.value,res.qtyPerHa,res.pricePerUnit)
        

      }
    );
  };

  
  // const productEdit = (editProductId) => {

  // }
  const submitProduct = (e) => {
    e.preventDefault();
    // console.log("productId", productId);
    if (productId === 0) {
      toast.error("Please select the product name");
      return;
    }
    var itemlist = productData.filter((item) => item.productId == productId);
    var selectedItem = itemlist[0];

    var productId1 = productId;
    var itemId = selectedItem.itemId;
    var productName = selectedItem.productName;
    var productSubType = productRef.current.productSubType.value;
    // var productType = productRef.current.productType.value;
    var availableQuantity = productRef.current.availableQty.value;
    var unit = productRef.current.unitName.value;
    var unitId1 = unitId;
    var _qtyPerHa = productRef.current.qtyPerHa.value;
    // var availableAmount1 = availableAmount;
    var quantity = productRef.current.quantity.value;
    var totalQuantity = quantity * availableQuantity;
    var pdlist = productDetails.filter((item) => item.productId == productId1);

    if (parseFloat(quantity ?? 0) <= 0) {
      toast.success("Please enter product quantity", {
        position: toast.POSITION.TOP_RIGHT,
      });
      return;
    }
    if (pdlist.length != 0) {
      toast.success("Product already present into the list", {
        position: toast.POSITION.TOP_RIGHT,
      });
      return;
    }

    setProductDetails((x) => [
      ...x,
      {
        srno:
          productDetails.length > 0
            ? productDetails[productDetails.length - 1].srno + 1
            : 1,
        productId: productId1,
        itemId: itemId,
        productName: productName,
        productType: productSubType,
        // productType: productType,
        currentQuantity: availableQuantity,
        quantity: quantity,
        unit: unit,
        unitId: unitId1,
        totalQuantity:  parseFloat(availableQuantity) -parseFloat(quantity),
        availableAmount: availableAmount,
        pricePerUnit: pricePerUnit,
        qtyPerHa: _qtyPerHa,
        itemQuantity: quantity,
        itemQuantityBal: quantity,
        productCost:(Math.round( (parseFloat(quantity)*pricePerUnit)*100) / 100)??0 ,               
        status: 1,
        createdBy: parseInt(localStorage.getItem("id")),
        orgId: localStorage.getItem("orgId"),
        // itemType: productRef.current.itemType.value,
        // itemCategory: productRef.current.itemCategory.value,
        // itemQuantity: productRef.current.itemQuantity.value,
        // unit: productRef.current.unit.value,
        // itemUnitPrice: productRef.current.itemUnitPrice.value,
        // rate: productRef.current.rate.value,
        // currency: productRef.current.currency.value,
        // totalAmount: productRef.current.totalAmount.value,
      },
    ]);

    setProductId(0);
    productRef.current.productSubType.value = "";
    console.log("productDetails",productDetails)
    productRef.current.unitName.value = "";
    productRef.current.availableQty.value = "";
    productRef.current.quantity.value = "";
    setunitId(0);
    setAvailableAmount(0);
    setPricePerUnit(0);
    productRef.current.qtyPerHa.value=0;
    // productRef.current.itemQuantity.value = "0";
  };
  const handleDelete = (index, e) => {
    setProductDetails(productDetails.filter((v, i) => i !== index));
  };

  const handleValidateQuantityChange = (event) => {
    var validator = new RegExp("^[0-9.]*$");

    var qtyvalid = validator.test(event.target.value);
    //console.log("handleValidateQuantityChange");
    //console.log(qtyvalid);
    if (qtyvalid) {
      var quantity = parseFloat(event.target.value);
      var totalquantity = parseFloat(
        productRef.current.availableQty.value
      );
      if (quantity > totalquantity) {
        event.target.value = 0;
        toast.success("Please enter quanitty less than total quantity", {
          position: toast.POSITION.TOP_RIGHT,
        });
      }
    } else {
      event.target.value = 0;
    }
  };

  const { sendRequest: getFITDetail } = useHttp();

  const FillFarmerInputTemplateDetail = (Id) => {
    // console.log("Template detail", Id);

    var farmerInputTemplateId = Id;
    setFarmerInputTemplateId(Id);
    getFITDetail(
      {
        url: `/api/farmerInputTemplateWithStock/?orgId=${localStorage.getItem(
          "orgId"
        )}&farmerInputTemplateId=${farmerInputTemplateId}&warehouseId=${warehouseId}`,
      },
      (res) => {
        if (res) {
          var farmerInputTempDetails = res.farmerInputTempDetails;
          setInputTemplateDetail(farmerInputTempDetails);
          

          var areaInHa = parseFloat(frmRef.current.areaInHa.value);
          var iCounter=0
          var newList=[];
          farmerInputTempDetails.forEach(function (itemData) {
            // console.log("item", itemData);

            //Build JSON
            iCounter=iCounter+1;
            newList = newList.concat(
              {
               "srno":  iCounter,
               "productId": itemData.productId,
               "itemId": itemData.itemId,
               "productName": itemData.productName,
               "productSubType": itemData.productSubType,
               "productType": itemData.productTypeName,
               "currentQuantity": itemData.currentStock,
               "unit": itemData.unitAbbreviation,
               "unitId": itemData.unitId,
                
                "currentAmount": itemData.currentStockAmount,
                "pricePerUnit": itemData.pricePerUnit,
                "quantity": parseFloat(itemData.quantity) * areaInHa,
                "itemQuantity": Math.round((parseFloat(itemData.quantity) * areaInHa)*100) / 100 ,
                "qtyPerHa": itemData.quantity,
                "itemQuantityBal": Math.round((parseFloat(itemData.quantity) * areaInHa)*100) / 100 ,
                "totalQuantity":Math.round((parseFloat(itemData.currentStock)  -(parseFloat(itemData.quantity) * areaInHa))*100) / 100 ,
                "damagedQuantity": 0,
                "productCost": (Math.round((parseFloat(itemData.currentStockAmount)/parseFloat(itemData.currentStock))*(parseFloat(itemData.quantity) * areaInHa)*100) / 100)??0  ,
                "status": 1,
                "createdBy": parseInt(localStorage.getItem("id")),
                "orgId": localStorage.getItem("orgId"),
              })

            // setProductDetails((x) => [
            //   ...x,
            //   {
            //     srno:
            //       productDetails.length > 0
            //         ? productDetails[productDetails.length - 1].srno + 1
            //         : 1,
            //     productId: itemData.productId,
            //     itemId: itemData.itemId,
            //     productName: itemData.productName,
            //     productSubType: itemData.productSubType,
            //     productType: itemData.productTypeName,
            //     currentQuantity: 0,
            //     unit: itemData.unitAbbreviation,
            //     unitId: itemData.unitId,
            //     currentAmount: 0,
            //     pricePerUnit: 0,
            //     quantity: parseFloat(itemData.quantity) * areaInHa,
            //     itemQuantity: parseFloat(itemData.quantity) * areaInHa,
            //     itemQuantityBal: parseFloat(itemData.quantity) * areaInHa,
            //     totalQuantity: 0,
            //     damagedQuantity: 0,
            //     status: 1,
            //     createdBy: parseInt(localStorage.getItem("id")),
            //     orgId: localStorage.getItem("orgId"),
            //   },
            // ]);

          });
          setProductDetails(newList)
          console.log("productDetails", newList);
        }
      }
    );
  };

  useEffect(() => {
    FillFarmerInputTemplateDetail(0);
  }, [getFITDetail]);

  const { sendRequest: postProcurementOfficer } = useHttp();

  const submitHandler = (e) => {
    e.preventDefault();

    setLoading(true);
    var errorflg=0
    productDetails.forEach(function (itemData) 
    {
      console.log("itemData",itemData.totalQuantity)
       if(parseFloat(itemData.totalQuantity)<0)
        {
          errorflg=1;
          toast.error(
            `Product name ${itemData.productName} has less quantity for issue.`
          );
          return false;
        } 
    });
 
    var templateId=""
    if (farmerInputTemplateId!=0)
    {
      templateId=farmerInputTemplateId;
    }
      

    if  (errorflg==0)
    {
    const data = {
      goodsTransferDate: moment(frmRef.current.date.value).format("DD/MM/YYYY"),
      seasonId: selectedSeasonId,
      goodsTransferFromWarehouseId: warehouseId,
      goodsTransferToOfficerEmpId: assignEmployeeId,
      // timeStamp: frmRef.current.time_stamp.value,
      productDetails: productDetails, 
      farmerInputTemplateId:templateId,
      goodsTransferType: "User",
      vehicleId:"",       
      driverName:  "",
      driverContactNo: "",
      startMeterReading: "0",
      endMeterReading: "0",
      areaInHa:frmRef.current.areaInHa.value,
      // remark: frmRef.current.remark.value,
      status: 1,
      createdBy: parseInt(localStorage.getItem("id")),
      orgId: localStorage.getItem("orgId"),
      serviceId: props.sId,
    };

    // const data = {
    //   openingStockDate: moment(frmRef.current.date.value).format("DD/MM/YYYY"),
    //   seasonId: selectedSeasonId,
    //   warehouseId: warehouseId,
    //   vendorId: selectedVendorId,
    //   areaInHa: areaInHa,
    //   farmerInputTemplateId: farmerInputTemplateId,
    //   status: 1,
    //   createdBy: parseInt(localStorage.getItem("id")),
    //   orgId: localStorage.getItem("orgId"),
    //   serviceId: 20,
    //   createdDate: dateString,
    //   productDetail: productDetails,
    // };
    // console.log("data", data);
    if (props.update) {
      data["openingStockId"] = props.update.openingStockId;
    }
    postProcurementOfficer(
      {
        url: "/api/procurementOfficer/",
        method: props.update ? "PUT" : "POST",
        body: data,
      },
      (data) => {
        //console.log(data);
        toast.success(
          `Procurement officer goods transfer note ${
            props.update ? "updated" : "added!"
          }`
        );
        props.addForm(false);
      },
      (error) => {
        console.error("Error", error);
        toast.error(error);
      }
    );
  }
  setLoading(false);
  };
  

  const CalculateGoodsQty = (_areaInHa, _qtyPerHa, _pricePerUnit) => {
    const area = _areaInHa || areaInHa; // Use provided value or state
    const qtyPerHa = productRef.current.qtyPerHa?.value;
    const price = productRef.current.pricePerUnit?.value;

    if (!area || !qtyPerHa || !price) return;

    const totalQtyRequired = parseFloat(area) * parseFloat(qtyPerHa);
    const totalAmountRequired =
      parseFloat(totalQtyRequired) * parseFloat(price);
    productRef.current.quantity.value = totalQtyRequired;
    productRef.current.goodsAmt.value = totalAmountRequired;
  };


  useEffect(() => {
    CalculateGoodsQty(areaInHa, qtyPerHa, pricePerUnit);
  }, [areaInHa, qtyPerHa, pricePerUnit]);



  useEffect(() => {
    if (props.update) {
      frmRef.current.date.value = moment(props.update.gtProcurementDate).format(
        "YYYY-MM-DD"
      );
      setProductDetails(props.update.productDetail);
    }
  }, [props.update]);

  return (
    <>
      <div className="content-wrapper">
        <div>&nbsp;</div>
        <section className="content">
          <form style={{ margin: "10px" }} onSubmit={submitHandler}>
            <div className="container-fluid">
              {/* SELECT2 EXAMPLE */}
              <div className="card card-default">
                <div className="card-header">
                  <h3 className="card-title">Add Distribution To Mobile User </h3>
                  <div className="card-tools">
                    <button
                      type="button"
                      className="btn btn-tool"
                      data-card-widget="remove"
                      onClick={() => props.addForm(false)}
                    >
                      <i className="fas fa-times" />
                    </button>
                  </div>
                </div>
                {/* /.card-header */}
                <div className="card-body">
                  <div className="row mb-2">
                    <div className="col-md-3">
                      <label htmlFor={"date"}>{"Date "}</label><b style={{color:"red"}}>*</b>
                      <input
                        type={"date"}
                        id={"date"}
                        required
                        ref={(el) => (frmRef.current["date"] = el)}
                        className="form-control"
                        max={currentDate}
                        value={selectedDate}
                        onChange={handleDateChange}
                      />
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"emp_id"}>{"Season"}</label><b style={{color:"red"}}>*</b>
                      <select
                        id="season_id"
                        className="form-control"
                        required
                        ref={(el) => (frmRef.current["selectedSeasonId"] = el)}
                        value={selectedSeasonId}
                        onChange={(e) => {
                         console.log("e.target.value",e.target.value)     
                          var seasonId=0
                          if( e.target.value!="--Select--")
                          {
                            seasonId=e.target.value;
                          }
                          setSelectedSeasonId(seasonId);                       
                          loadExecutiveArea(assignEmployeeId,seasonId);

                        }}
                      >
                        <option selected value="--Select--"  >
                          --Select--
                        </option>
                        {seasonlist &&
                          seasonlist.map((x) => (
                            <option
                              key={x.seasonId}
                              employee-id={x.seasonId}
                              value={x.seasonId}
                            >
                              {x.seasonName}
                            </option>
                          ))}
                      </select>
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"warehouseId"}>{"Warehouse"}</label>
                      <b style={{color:"red"}}>*</b>
                      <select
                        id="warehouseId"
                        className="form-control"
                        ref={(el) => (frmRef.current["warehouseId"] = el)}
                        value={warehouseId}
                        required
                        onChange={(e) => {
                          setWarehouseId(e.target.value);
                        }}
                      >
                        <option selected  >
                          Select Warehouse
                        </option>
                        {warehosuedata &&
                          warehosuedata.map((x) => (
                            <option key={x.id} warehouse-id={x.id} value={x.id}>
                              {x.name} {}
                            </option>
                          ))}
                      </select>
                    </div>
                    <div className="col-md-3">
                     

                    <label htmlFor={"emp_id"}>
                        {"Field Executive"}
                      </label> <b style={{color:"red"}}>*</b>
                      <select
                        id="emp_id"
                        className="form-control"
                        required
                        ref={(el) => (frmRef.current["assignEmployeeId"] = el)}
                        value={assignEmployeeId}
                        onChange={(e) => {

                          var empId=0
                            if( e.target.value!="--Select--")
                            {
                              empId=e.target.value;
                            }
                            
                              setAssignEmployeeId(empId);
                              loadExecutiveArea(empId,selectedSeasonId);
                        }}
                      >
                        <option selected  >
                        --Select--
                        </option>
                        {employeelist &&
                          employeelist.map((x) => (
                            <option
                              key={x.empId}
                              employee-id={x.empId}
                              value={x.empId}
                            >
                              {x.employeeName}
                            </option>
                          ))}
                      </select>
                    </div>
                  </div>
                  <div className="row mb-2">
                    <div className="col-md-2">
                      {" "}
                      <label>Area</label>
                      <input
                        type={"text"}
                        id={"areaInHa"}
                        ref={(el) => (frmRef.current["areaInHa"] = el)}
                        className="form-control"
                         
                        defaultValue={50}                         
                        onChange={(e) => {
                          setAreaInHa(e.target.value);
                          CalculateGoodsQty(e.target.value, qtyPerHa, pricePerUnit);
                          
                        }}
                      />
                    </div>

                    <div className="col-md-1 d-flex align-items-center">
                      <p className="font-weight-bold m-1 pt-4 text-start">Ha</p>
                    </div>

                    <div className="col-md-3">
                      {" "}
                      <label>Farmer Input Template</label>
                      <select
                        id="farmerInputTemplate"
                        className="form-control"
                         
                        ref={(el) =>
                          (frmRef.current["farmerInputTemplate"] = el)
                        }
                        value={selectedFarmerId}
                        onChange={(e) => {
                          FillFarmerInputTemplateDetail(e.target.value);
                        }}
                      >
                        <option selected disabled value="">
                          Select Farmer Input Template
                        </option>
                        {farmerData &&
                          farmerData.map((x) => (
                            <option
                              key={x.farmerInputTemplateId}
                              employee-id={x.farmerInputTemplateId}
                              value={x.farmerInputTemplateId}
                            >
                              {x.templateName}
                            </option>
                          ))}
                      </select>
                    </div>
                  </div>
                  <br />
                  <h4>{"Product Detail"}</h4>
                      <hr/>
                 
                  <div className="row">
                    <div className="col-md-3">
                      {" "}
                      <label htmlFor={"productId"}> Product </label>
                      <select
                        id="productId"
                        className="form-control"
                        ref={(el) => (frmRef.current["productId"] = el)}
                        value={productId}
                        onChange={(e) => {
                          var _productId = 0;
                          if (e.target.value != "--Select Product Name--") {
                            _productId = e.target.value;
                          }
                          setProductId(_productId);
                          loadStockData(_productId);
                        }}
                      >
                        <option>Select Product</option>
                        {productData &&
                          productData.map((x) => (
                            <option
                              key={x.productId}
                              product-id={x.productId}
                              value={x.productId}
                            >
                              {x.productName + "(" + x.itemId + ")"}
                            </option>
                          ))}
                      </select>
                    </div>
                    <div className="col-md-3">
                      {" "}
                      <label htmlFor={"productId"}>
                        {" "}
                        Product SubType{" "}
                      </label>{" "}
                      <input
                        type={"input"}
                        id={"itemType"}
                        readOnly
                        ref={(el) =>
                          (productRef.current["productSubType"] = el)
                        }
                        className="form-control"
                      />{" "}
                    </div>

                    <div className="col-md-3">
                      {" "}
                      <label htmlFor={"unitName"}> Unit</label>
                      <input
                        type={"input"}
                        id={"itemType"}
                        readOnly
                        ref={(el) => (productRef.current["unitName"] = el)}
                        className="form-control"
                      />
                      
                    </div>

                    <div className="col-md-3">
                      {" "}
                      <label htmlFor={"pricePerUnit"}>Rate/Unit</label>
                      <input
                        type={"input"}
                        id={"pricePerUnit"}
                        ref={(el) => (productRef.current["pricePerUnit"] = el)}
                        className="form-control"
                        value={pricePerUnit}
                        onChange={(e) => {
                          setPricePerUnit(e.target.value);
                          // CalculateGoodsQty(areaInHa, qtyPerHa, e.target.value);
                        }}
                      />
                    </div>
                    </div>
                    <div className="row">

                    <div className="col-md-3">
                      {" "}
                      <label htmlFor={"qtyPerHa"}>Quantity/Ha</label>
                      <input
                        type={"input"}
                        id={"qtyPerHa"}
                        ref={(el) => (productRef.current["qtyPerHa"] = el)}
                        className="form-control"
                        value={qtyPerHa}
                        onChange={(e) => {
                          setQtyPerHa(e.target.value);
                          CalculateGoodsQty(areaInHa, e.target.value, pricePerUnit);
                        }}
                      />
                    </div>
                    
                    <div className="col-md-3">
                      {" "}
                      <label htmlFor={"availableQty"}> Current Quantity</label>
                      <input
                        type={"input"}
                        id={"itemType"}
                        readOnly
                        ref={(el) => (productRef.current["availableQty"] = el)}
                        className="form-control"
                      />
                    </div>

                    <div className="col-md-3">
                      <label htmlFor={"quantity"}> Goods Issue Qty</label>
                      <input
                        type={"input"}
                        id={"itemType"}
                        ref={(el) => (productRef.current["quantity"] = el)}
                        className="form-control"
                        pattern={decimalPattern}
                        onChange={(e) => {
                          handleValidateQuantityChange(e);
                        }}
                      />
                    </div>
                    <div className="col-md-3">
                      {" "}
                      <label htmlFor={"goodsAmt"}>Goods Amount</label>
                      <input
                        type={"input"}
                        id={"goodsAmt"}
                        ref={(el) => (productRef.current["goodsAmt"] = el)}
                        className="form-control"
                      />
                    </div>
                  </div>

                  <div className="row">

                  <div className="col-md-3"></div>
                  <div className="col-md-3"></div>
                  <div className="col-md-3"></div>
                  <div className="col-md-1 my-1">
                      {" "}
                      <button
                        className="btn btn-success mx-2 my-4"
                        onClick={submitProduct}
                      >
                        +
                      </button>{" "}
                    </div>
                  </div>
                  
                  
                  
                  <div className="row">
                    <div className="col-md-12">
                      <table className="table table-bordered text-center">
                        <thead>
                          <tr className="tableheaderrowview">
                            <th>Sr No.</th>
                            
                            <th>Product Sub Type</th>
                            <th>Product</th>
                            <th>Unit</th>
                            <th>Rate/Unit</th>
                            <th>Quantity/Ha</th>
                            <th>Current Quantity</th>
                            <th>Goods Issue Quantity</th>
                             <th>Goods Issue Amount</th> 
                            <th>Total Balance Quantity</th>
                            {/* <th>Edit</th> */}
                          </tr>
                        </thead>
                        <tbody>
                          {productDetails.length > 0 ? (
                            productDetails.map((items, index) => (
                              <tr key={index}>
                                
                                <td>
                                  {index+1}
                                </td>
                                <td>{items.productType}</td>
                                <td>{items.productName}</td>
                                <td>{items.unit}</td>
                                <td>{items.pricePerUnit}</td>
                                <td>{items.qtyPerHa}</td>
                                <td>{items.currentQuantity}</td>
                                <td>{items.itemQuantity}</td>
                               <td>{items.productCost}</td> 
                                <td>{items.totalQuantity}</td>
                                {/* <td>
                                  <button
                                    className="btn"
                                    // onClick={() => {
                                    //   props.update(items);
                                    //   props.addForm(true);
                                    // }}

                                    onClick={productEdit(items.productId)}
                                  >
                                    {" "}
                                    <i className="fas fa-edit"></i>
                                  </button>
                                </td> */}
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan="9">No data present</td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>

                  <div className="row mb-2">
                    <div className="col-md-4"></div>
                    <div className="col-md-1"> </div>
                    <div className="col-md-1">
                      {" "}
                      <button
                        className="btn  btn-primary mx-2 my-2"
                        type="submit"
                        disabled={loading}
                      >
                        {loading ? "Submitting..." : "Submit"}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </section>
      </div>
    </>
  );
};

export default DistributionToMobileUserForm;
